const CryptoJS = require('crypto-js')
const crypto = require('crypto')
const Rijndael = require('rijndael-js')

module.exports = {
  getCipher(name, salt) {
    const key = crypto.createHash('md5').update(`${salt}${name}`).digest('hex')
    return new Rijndael(key, 'ecb')
  },

  encrypt(name, value, salt) {
    const cipher = this.getCipher(name, salt)

    const base64EncodedValue = this.base64Encode(value)
    const ciphertext = Buffer.from(cipher.encrypt(base64EncodedValue, 128))
    const encrypted = ciphertext.toString('base64')

    return this.urlEncodeBase64(encrypted)
  },

  decrypt(name, encryptedValue, salt) {
    const cipher = this.getCipher(name, salt)
    const urlDecodedBase64EncryptedValue = this.urlDecodeBase64(encryptedValue)
    try {
      const cipherText = Buffer.from(urlDecodedBase64EncryptedValue, 'base64')
      const decrypted = Buffer.from(cipher.decrypt(cipherText, 128)).toString()
      return this.base64Decode(decrypted.toString(CryptoJS.enc.Utf8)).replace(/\0/g, '')
    } catch (error) {
      throw new Error(`Error with decrypting ${name} with error: ${error.message}`)
    }
  },

  dynamicDecrypt(name, encryptedValue, uuid, email) {
    if (!['ban', 'sub'].includes(name)) {
      throw new Error('First argument must only be "ban" or "sub"')
    }

    if (!this.isValidUuid(uuid)) {
      throw new Error('Third argument must be a valid uuid')
    }

    if (!this.isValidEmail(email)) {
      throw new Error('Fourth argument must be a valid email')
    }

    try {
      const value = this.decrypt(name, encryptedValue, email)

      if (this.isValidBanOrSub(name, value)) {
        return value
      }

      throw 'fallback to decryption with uuid'
    } catch (err) {
      const value = this.decrypt(name, encryptedValue, uuid)

      if (this.isValidBanOrSub(name, value)) {
        return value
      }
    }

    throw new Error(`Unable to decrypt ${name}: ${encryptedValue}`)
  },

  base64Encode(parameter) {
    const wordArray = CryptoJS.enc.Utf8.parse(parameter)
    return CryptoJS.enc.Base64.stringify(wordArray)
  },

  base64Decode(parameter) {
    return CryptoJS.enc.Base64.parse(parameter).toString(CryptoJS.enc.Utf8)
  },

  urlEncodeBase64(param) {
    return param.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
  },

  urlDecodeBase64(param) {
    return param.replace(/-/g, '+').replace(/_/g, '/')
  },

  isValidBanOrSub(type, value) {
    if (type === 'ban') {
      return new RegExp(/^[0-9]+$/).test(value)
    }
    if (type === 'sub') {
      return new RegExp(/^\d{3}-?\d{3}-?\d{4}$/).test(value)
    }
    return false
  },

  isValidEmail(email) {
    const emailRegex = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
    return emailRegex.test(email)
  },

  isValidUuid(uuid) {
    const uuidRegex = new RegExp(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{11,12}$/i)
    return uuidRegex.test(uuid)
  }
}
